import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import AtomNotice from '@/components/Atoms/AtomNotice/AtomNotice'

import {
  getFirstQuantityHeader,
  getQuantityHeaderEntries,
  hasDifferentQuantityHeaders,
} from '../../../lib/stockImportsQuantityHeaders'
import { labelWithTooltip } from '../../../RequiredLabel/labelWithTooltip'
import type { ConfigPreviewResponse } from '../../../types/stockImports.types'
import {
  type ConfigFieldContext,
  ConfigTextField,
} from '../../ConfigFields/ConfigFields'
import { CONFIG_TOOLTIPS } from '../../lib/configModalTexts'
import fieldsCn from './ImportProtectionFields.module.scss'

type QuantityHeaderFieldProps = {
  context: ConfigFieldContext
  quantityHeaders: ConfigPreviewResponse['quantityHeaders']
  onUseQuantityHeader: (header: string) => void
}

const EMPTY_HEADER_LABEL = 'пусто'

function QuantityHeaderField({
  context,
  quantityHeaders,
  onUseQuantityHeader,
}: QuantityHeaderFieldProps) {
  const headerEntries = getQuantityHeaderEntries(quantityHeaders)
  const firstHeader = getFirstQuantityHeader(quantityHeaders)

  return (
    <div className={fieldsCn.headerField}>
      <ConfigTextField
        context={context}
        name="expectedQuantityHeader"
        title={labelWithTooltip(
          'Ожидаемый заголовок остатка',
          CONFIG_TOOLTIPS.expectedQuantityHeader
        )}
        placeholder="Например: Остаток"
      />
      {headerEntries.length > 0 && (
        <div className={fieldsCn.previewHeaders}>
          <span>Заголовки в файле:</span>
          {headerEntries.map(([sheetName, header]) => (
            <span key={sheetName} className={fieldsCn.previewHeader}>
              {sheetName}: «{header ?? EMPTY_HEADER_LABEL}»
            </span>
          ))}
          {firstHeader !== null && (
            <AtomButton
              variant="secondary"
              onClick={() => onUseQuantityHeader(firstHeader)}
            >
              Подставить из файла
            </AtomButton>
          )}
        </div>
      )}
      {hasDifferentQuantityHeaders(quantityHeaders) && (
        <AtomNotice type="warning">
          На листах разные заголовки колонки количества: проверка не пройдёт на
          части листов
        </AtomNotice>
      )}
    </div>
  )
}

export default QuantityHeaderField
